import { render, staticRenderFns } from "./ScientificActivityTabEvents.vue?vue&type=template&id=c1414ac2&scoped=true"
import script from "./ScientificActivityTabEvents.vue?vue&type=script&lang=js"
export * from "./ScientificActivityTabEvents.vue?vue&type=script&lang=js"
import style0 from "./ScientificActivityTabEvents.vue?vue&type=style&index=0&id=c1414ac2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1414ac2",
  null
  
)

export default component.exports